import request from '@/utils/http.js';

export function queryMatchList(options) {
    return request({
        url: '/newsPro/selectNewsDetailed',
        method: 'post',
        data: options
    })
}
